import React from "react";
import HeroTC from "../Components/Hero/HeroT&C";

const TermsAndConditions = () => {
  return (
    <>
      <HeroTC />
      <section className="st-about-wrap" id="about">
        <div className="container">
          <div className="col-lg">
            <p>
              By accessing or using our application, you agree to be bound by
              the following terms and conditions. Please read them carefully
              before proceeding.
            </p>

            <h4>1. Acceptance of Terms:</h4>
            <p>
              By downloading or using Dotor Samaj Community, you agree to these
              terms and all applicable laws and regulations. If you do not
              agree, discontinue using the app.
            </p>

            <h4>2. Community Verification:</h4>
            <ul>
              <li>
                This app is exclusively for members of the Dotor Samaj
                community.
              </li>
              <li>
                Registrations are manually verified by the Admin. Approval is at
                the sole discretion of the Admin team.
              </li>
            </ul>

            <h4>3. Use of Content:</h4>
            <ul>
              <li>
                The content within the app is for community use and may not be
                copied, distributed, or used commercially without permission.
              </li>
              <li>Users are solely responsible for the content they upload.</li>
            </ul>

            <h4>4. Liability:</h4>
            <ul>
              <li>
                We are not liable for user-generated content, damages caused by
                misuse of the app, or any data breaches or hacks. You are solely
                responsible for securing your data and protecting your personal
                information.
              </li>
              <li>
                The app is provided “as-is” without warranties of any kind.
              </li>
            </ul>

            <h4>5. Dispute Resolution:</h4>
            <p>
              Any disputes arising from these terms will be governed by the laws
              of India.
            </p>

            <p>
              If you have any questions or concerns about these terms, please
              contact us at{" "}
              <a href="mailto:support@dotor.org">support@dotor.org</a>.
            </p>
            <div className="st-height-b125 st-height-lg-b25" />

            <div className="st-height-b0 st-height-lg-b30" />
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsAndConditions;
